module.exports = __webpack_public_path__ + "svg/logo_visa.cc93dcf23ddaa2723f35615e7857fd2c.svg";